var _style, _g, _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExerciseSliderIconWhite5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 92.1 95.5",
    style: {
      enableBackground: "new 0 0 92.1 95.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6A8BE5;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#FFFFFF;stroke-width:4;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#FFFFFF;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;}\n\t\n\t\t.st4{fill:none;stroke:#FFFFFF;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:3.9248,3.9248,1.0902,3.9248;}\n\t.st5{fill:none;stroke:#FFFFFF;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:9.8371,9.8371;}\n\t.st6{fill:none;stroke:#FFFFFF;stroke-width:4.0826;stroke-miterlimit:10;}\n\t.st7{fill:none;stroke:#FFFFFF;stroke-width:4.3666;stroke-miterlimit:10;}\n\t.st8{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52.2,9.2v4.4c-2-0.3-4-0.5-6.1-0.5c-2,0-3.9,0.1-5.8,0.4V9.2c0-2.4,1.9-4.3,4.3-4.3H48 C50.3,5,52.2,6.9,52.2,9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M25.8,18.9c-1.1,0.7-2.2,1.5-3.3,2.3l-2.7-2.7c-0.8-0.8-0.8-2,0-2.7l0.1,0c0.8-0.8,2-0.8,2.7,0L25.8,18.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M72.5,18.5l-2.7,2.7c-1-0.8-2.1-1.6-3.3-2.3l3.2-3.2c0.8-0.8,2-0.8,2.7,0l0,0C73.3,16.5,73.3,17.8,72.5,18.5z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 46.2,
    cy: 52.1,
    r: 38.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M46.2,82.8c-16.9,0-30.7-13.8-30.7-30.7c0-16.9,13.8-30.7,30.7-30.7s30.7,13.8,30.7,30.7 C76.9,69,63.1,82.8,46.2,82.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExerciseSliderIconWhite5);
export default __webpack_public_path__ + "static/media/exercise_slider_icon_white_5.09294183.svg";
export { ForwardRef as ReactComponent };